export default __webpack_public_path__ + "static/media/Apple (1).f3c1b6ca.jpg";